import * as React from 'react';
const SvgInfo = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props} viewBox="0 0 24 24">
        <path fill="none" d="M0 0h24v24H0z" />
        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z" />
    </svg>
);
export default SvgInfo;
